

import { useCashier } from '../contexts/CashierProvider';
import Loading from '../components/Loading';
import ForbiddenAccessPage from '../pages/ForbiddenAccessPage';
import { useTranslation } from 'react-i18next';

export default function CashierSignInGuard({ children }: { children: React.ReactNode }) {
    const { isSignedIn, loading } = useCashier();
    const { t } = useTranslation();

    if (loading) {
        return <Loading />; // Or a loading spinner
    }
    if (!isSignedIn) {
        return (
            <ForbiddenAccessPage
                message={t('guard.cashier_signin.forbidden_message', { defaultValue: 'Cashier sign in is required.' })}
            />
        );
    }
    return <>{children}</>;
}